import React, { useEffect, useState } from 'react';
import { Button, Alert, Checkbox } from '@emorg-prd/react-standard';
import './index.css';
import DisplayLocation from '../../displayLocation';
import Location from '../../../../api/Location';
import { useNavigate } from 'react-router-dom';
import LoaderIcon from '../../../loaderIcon';
import UnprocessedLocation from '../../../../api/UnprocessedLocation';
import ProgressTabNavigator from '../ProgressTabNavigator';

function ReviewFinish(props) {
  const {
    locationState,
    onNavigateBackward,
    onSetProgressTabComplete,
    isFormComplete,
    onChange,
    isAuthorized,
    sourceSystemTypeList,
    sourceSystemList
  } = props;
  const [loadingIconVisible, setloadingIconVisible] = useState(false);
  const [checkedConnexion, setCheckedConnexion] = useState(false);
  const [unprocessedLocationConnexion, setUnprocessedLocationConnexion] = useState('');
  const [showConnexionSourceSystemAlert, setShowConnexionSourceSystemAlert] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState('');
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState('');
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  let navigate = useNavigate();
  let existingSapCode = null;
  let connexionSourceName = 'connexion';
  let connexionSapSourceTypeName = 'sap_location_code';

  useEffect(() => {
    onSetProgressTabComplete();

    UnprocessedLocation.get(props.locationId).then((res) => {
      if (res) {
        if (res.Connexion && !res.processedOnConnexion) {
          setUnprocessedLocationConnexion('Not Processed.');
        } else if (res.Connexion) {
          var sqlDate = res.processedOnConnexion.split(/[- : T]/);
          var date = new Date(Date.UTC(sqlDate[0], sqlDate[1] - 1, sqlDate[2]))
            .toLocaleDateString('en-us', { month: 'short', day: 'numeric', year: 'numeric'});
          setUnprocessedLocationConnexion('Recent changes not saved. Last processed on ' + date + '.');
        }
      }
    });

    if (
      isConnexionSourceSystem(locationState.sourceSystemLinkList) ||
      locationState.isCheckedConnexion
    ) {
      handleCheckConnexion(true);
    }
  }, []);

  const handleCheckConnexion = (checked) => {
    setCheckedConnexion(checked);
    locationState.isCheckedConnexion = checked;
    existingSapCode = locationState.sourceSystemLinkList.find((source) =>
      source.sourceSystemIdTypeName.toLowerCase() === connexionSapSourceTypeName &&
      source.sourceSystemReferenceId !== ''
    );
    let existingSapRow = locationState.sourceSystemLinkList.find((source) =>
      source.sourceSystemIdTypeName.toLowerCase() === connexionSapSourceTypeName
    );

    if (!existingSapCode) {
      setShowConnexionSourceSystemAlert(true);
      onSetProgressTabComplete();

      if (!existingSapRow && checked) {
        let sourceSystemId = '';
        let sourceSystemName = '';
        let sourceSystemIsActive = true;
        let sourceSystemIdTypeId = '';
        let sourceSystemIdTypeName = '';
        let sourceSystemIdTypeIsActive = true;

        if (sourceSystemList) {
          sourceSystemList.forEach((source) => {
            if (source.sourceSystemName.toLowerCase() === connexionSourceName) {
              sourceSystemId = source.sourceSystemId;
              sourceSystemName = source.sourceSystemName;
            }
          });
        }

        if (sourceSystemTypeList) {
          sourceSystemTypeList.forEach((type) => {
            if (
              type.sourceSystemIdTypeName.toLowerCase() === connexionSapSourceTypeName &&
              type.sourceSystemId === sourceSystemId
            ) {
              sourceSystemIdTypeId = type.sourceSystemIdTypeId;
              sourceSystemIdTypeName = type.sourceSystemIdTypeName;
            }
          });
        }
        let sourceSystemLinkListCopy = [...locationState.sourceSystemLinkList];
        sourceSystemLinkListCopy.push({
          sourceSystemId: sourceSystemId,
          sourceSystemName: sourceSystemName,
          sourceSystemIsActive: sourceSystemIsActive,
          sourceSystemIdTypeId: sourceSystemIdTypeId,
          sourceSystemIdTypeName: sourceSystemIdTypeName,
          sourceSystemIdTypeIsActive: sourceSystemIdTypeIsActive,
          sourceSystemReferenceId: '',
        });
        onChange('sourceSystemLinkList', sourceSystemLinkListCopy);
      }
    } else {
      setShowConnexionSourceSystemAlert(false);
    }
  };

  const submitNewLocationForm = async () => {
    setShowConnexionSourceSystemAlert(false);
    setloadingIconVisible(true);
    updateDestinationSystem();
    const newLocationObject = new Location(locationState);

    Location.create(newLocationObject).then((res) => {
      if (res.data.isSuccess) {
        let addedLocationId = res.data.confirmation;
        setSuccessAlertMessage(res.data.message + ' Redirecting...');
        setShowSuccessAlert(true);
        setTimeout(() => {
          navigate('/viewlocation/' + addedLocationId);
        }, 8000);
      } else {
        let locationId = res.data.confirmation;
        var innerException = res.data.innerException;
        setErrorAlertMessage(res.data.message);
        setShowErrorAlert(true);
      }
      setloadingIconVisible(false);
    });
  };

  const submitUpdateLocationForm = async () => {
    setloadingIconVisible(true);
    updateDestinationSystem();
    let updateLocationObject = new Location(locationState);
    updateLocationObject.locationId = props.locationId;
    updateLocationObject.stewardshipCostObjectList.forEach((element) => {
      element.locationId = props.locationId;
    });
    updateLocationObject.sourceSystemLinkList.forEach((element) => {
      element.locationId = props.locationId;
    });
    updateLocationObject.businessLineAllocationList.forEach((element) => {
      element.locationId = props.locationId;
    });
    updateLocationObject.epsBusinessLineAllocationList.forEach((element) => {
      element.locationId = props.locationId;
    });
    updateLocationObject.realEstateInterestList.forEach((rei) => {
      rei.locationId = props.locationId;
      rei.realEstateInterestSourceSystemRelate.forEach((reiSourceSytem) => {
        reiSourceSytem.realEstateInterestId = rei.realEstateInterestId;
      });
    });
    Location.update(updateLocationObject).then((res) => {
      if (res.data.isSuccess) {
        setSuccessAlertMessage(res.data.message + ' Redirecting...');
        setShowSuccessAlert(true);
        setTimeout(() => {
          window.location.reload();
        }, 8000);
      } else {
        setErrorAlertMessage(res.data.message);
        setShowErrorAlert(true);
      }
      setloadingIconVisible(false);
    });
  };

  const isConnexionSourceSystem = (sourceSystemList) => {
    let isConnexionSource = sourceSystemList.find((source) =>
      source.sourceSystemName.toLowerCase() === connexionSourceName &&
      source.sourceSystemIdTypeName.toLowerCase() === connexionSapSourceTypeName
    );
    return isConnexionSource ? true : false;
  };

  const updateDestinationSystem = () => {
    if (checkedConnexion) {
      locationState.destinationSystem.Connexion = 1;
    }
  };

  return (
    <div className='page'>
      {loadingIconVisible && <LoaderIcon />}
      <DisplayLocation {...locationState} />

      <article className='alert-grid'>
        <div className='alert-grid-row'>
          <Alert
            variant='warning'
            className='review-alert'
            style={{ display: showConnexionSourceSystemAlert ? 'flex' : 'none' }}
          >
            Please complete the Connexion SAP Location Code on Step 2!
          </Alert>
        </div>
      </article>

      <article className='alert-grid'>
        <div className='alert-grid-row'>
          <Alert
            variant='success'
            className='review-alert'
            style={{ display: showSuccessAlert ? 'flex' : 'none' }}
          >
            {successAlertMessage}
          </Alert>
        </div>
      </article>

      <article className='alert-grid'>
        <div className='alert-grid-row'>
          <Alert
            variant='error'
            className='review-alert'
            style={{ display: showErrorAlert ? 'flex' : 'none' }}
          >
            {errorAlertMessage}
          </Alert>
        </div>
      </article>

      <Checkbox.Group label='Save Options'>
        <Checkbox
          style={{ border: 0, background: 'transparent' }}
          className='checkbox'
          label='Connexion'
          id='connexionCheckbox'
          checked={checkedConnexion}
          onChange={(checked) => handleCheckConnexion(checked)}
        />
        <p style={{ fontSize: 'small', margin: '0px 0px 15px 8px' }}>
          {unprocessedLocationConnexion}
        </p>
      </Checkbox.Group>

      <div style={{ display: 'flex' }}>
        <ProgressTabNavigator
          onNavigateBackward={onNavigateBackward}
        >
        </ProgressTabNavigator>
        {props.locationId ? (
          <Button
            className='small-margin'
            variant='primary'
            onClick={submitUpdateLocationForm}
            disabled={!isFormComplete || !isAuthorized}
          >
            Save Changes
          </Button>
        ) : (
          <Button
            className='small-margin'
            variant='primary'
            onClick={submitNewLocationForm}
            disabled={!isFormComplete || !isAuthorized}
          >
            Create Location
          </Button>
        )}
      </div>
    </div>
  );
}

export default ReviewFinish;
